<div class="grid gap-3">
  <!-- Residential -->
  <shared-button-with-image
    headline="Residential"
    description="A property you own and currently live in."
    imagePath="/assets/images/dialog-house-residential.png"
    contentStyleClass="bg-light w-100"
    (click)="addProperty(ENUM_PropertyInvestmentType.PROPERTY_INVESTMENT_TYPE_RESIDENTIAL)" />

  <!-- Buy to let -->
  <shared-button-with-image
    headline="Buy to let"
    description="An investment property that you own and rent out."
    imagePath="/assets/images/house-coin.png"
    contentStyleClass="bg-light w-100"
    (click)="addProperty(ENUM_PropertyInvestmentType.PROPERTY_INVESTMENT_TYPE_BUY_TO_LET)" />

  <!-- Want to buy (Smart search) -->
  <shared-button-with-image
    *hasCompanyClientUiSettingsEnabled="showSmartSearchKey"
    headline="Want to buy"
    description=" A placeholder for a property your looking to buy but don't currently own."
    imagePath="/assets/images/dialog-house-glass.png"
    contentStyleClass="bg-light w-100"
    (click)="openSmartSearch()" />
</div>
